import React, { useState } from 'react';
import '../../../styles/globals.css'
import { Box, Typography } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import DashboardLogoutFooterComponent from '../footer/DashboardLogoutFooterComponent';
import AdminDashboardMenuHeaderComponent from './header/AdminDashboardMenuHeaderComponent';

function AdminDashboardRoot() {

    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    RedirectIfNotLoggedIn();

    return (
        <>
            <Box className={karmaStyles.homepageBox}>
                <AdminDashboardMenuHeaderComponent
                    homeEnabled={true} />
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        Admin - Home
                    </Typography>
                    <Typography variant="body2" component="div" gutterBottom sx={{fontWeight: "bold"}}>
                        <a href="/karma/dashboard">User Dashboard (back)</a>
                    </Typography>
                </Box>
            </Box>
            <DashboardLogoutFooterComponent />
        </>
    );
}

export default AdminDashboardRoot;


